import { usePatchAnnotation, usePostAnnotation } from '@/api/rest/resources/conversation';
import { Annotation } from '@/api/rest/resources/types/conversation';

export const useCreateOrganizationAnnotation = () => {
  const mutation = usePostAnnotation();
  return useOrganizationAnnotationsMutation(mutation);
};

export const useUpdateOrganizationAnnotation = () => {
  const mutation = usePatchAnnotation();
  return useOrganizationAnnotationsMutation(mutation);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useOrganizationAnnotationsMutation = (mutation: any) => {
  const submit = async (
    organizationId: string,
    conversationId: string,
    messageId: string,
    annotation: Partial<Annotation>,
    onSuccess?: () => void,
  ) => {
    const response = await mutation.mutateAsync({
      pathVariables: { organization_id: organizationId },
      queryParams: { conversation_id: conversationId, message_id: messageId, annotation_id: annotation.id ?? null },
      bodyData: annotation,
    });

    onSuccess?.();

    return response;
  };

  const isSubmitting = mutation.isPending;

  return { submit, isSubmitting };
};
